import {
  styled,
  Tooltip as MuiTooltip,
  tooltipClasses as muiTooltipClasses,
  TooltipProps as MuiTooltipProps,
} from '@mui/material';

export interface Props extends Omit<MuiTooltipProps, 'arrow' | 'disableInteractive' | 'placement'> {
  /** @default true */
  arrow?: MuiTooltipProps['arrow'];
  /** @default true */
  disableInteractive?: MuiTooltipProps['disableInteractive'];
  /** @default 'top' */
  placement?: MuiTooltipProps['placement'];
}

export const StyledTooltip = styled(({ className, ...props }: Props) => (
  <MuiTooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${muiTooltipClasses.tooltip}`]: {
    padding: theme.spacing(2, 3),
    backgroundColor: theme.palette.grey[900],
    lineHeight: 1.5,
  },
  [`& .${muiTooltipClasses.arrow}`]: {
    color: theme.palette.grey[900],
  },
}));

export { muiTooltipClasses };
